module.exports = __webpack_public_path__ + "images/d-belousov-33ba79.jpg";